import React, { Component } from 'react'
import { Dropdown } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './Motion.css';

export default class Motion extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading: true
        }
    }

    renderImage(imageUrl) {
        return (
            <div className="col-6 spacingBtm" key={imageUrl.key}>
                <div className="container">
                    <img className="gif" alt={imageUrl.alt} src={require('../media/' + imageUrl.img + ".gif")} />
                </div>
            </div>
        );
    }

    render() {
        return (
            <div className="motion top">
                <div className="title">
                    <Dropdown>
                        <Dropdown.Toggle className="dropdownTitle">
                            MOTION
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <LinkContainer to="/branding">
                                <Dropdown.Item >BRANDING</Dropdown.Item>
                            </LinkContainer>
                            <LinkContainer to="/invitations">
                                <Dropdown.Item>INVITATIONS</Dropdown.Item>
                            </LinkContainer>
                            <LinkContainer to="/infographics">
                                <Dropdown.Item>INFOGRAPHICS</Dropdown.Item>
                            </LinkContainer>
                            <LinkContainer to="/UxUi">
                                <Dropdown.Item>UI/UX</Dropdown.Item>
                            </LinkContainer>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className="row">
                    {this.props.motion.map(imageUrl => this.renderImage(imageUrl))}
                </div>
            </div >
        )
    }
}